import SaveBookmarksUseCase from "@domains/features/Bookmarks/useCases/SaveBookmarksUseCase";
import DeleteBookmarksUseCase from "@domains/features/Bookmarks/useCases/DeleteBookmarksUseCase";
import FetchBookmarksUseCase from "@domains/features/Bookmarks/useCases/FetchBookmarksUseCase";
import BookMarkFiltersUseCase from "@domains/features/Bookmarks/useCases/BookMarkFiltersUseCase";
export default (function (repositories) {
    return {
        bookmarks: {
            saveBookmarks: new SaveBookmarksUseCase(repositories.bookmarks),
            fetchBookmarks: new FetchBookmarksUseCase(repositories.bookmarks),
            deleteBookmarks: new DeleteBookmarksUseCase(repositories.bookmarks),
            bookmarkFilters: new BookMarkFiltersUseCase(repositories.bookmarks),
        },
    };
});
